// ===========================================================================
// 네이티브 프로토콜 타입 선언
// ===========================================================================
declare global {
  interface Window {
    nativeBridge: {
      request: (message: string) => void;
    };
    webkit: {
      messageHandlers: {
        request: {
          postMessage: (message: string) => void;
        };
      };
    };
  }
}

// ===========================================================================
// Android 확인
// ===========================================================================
export function isAndroid(){
  return typeof window.nativeBridge?.request === 'function';
}

// ===========================================================================
// iOS 확인
// ===========================================================================
export function isIOS(){
  return !!(window.webkit && window.webkit.messageHandlers && window.webkit.messageHandlers.request);
}

// ===========================================================================
// 네이티브 프로토콜 요청
// ===========================================================================
export function request(message: Record<string, unknown>){
  if (isAndroid()) {
    console.log('nativeBridge.request', JSON.stringify(message));
    window.nativeBridge.request(JSON.stringify(message));
  } else if (isIOS()) {
    console.log('webkit.messageHandlers.request', JSON.stringify(message));
    window.webkit.messageHandlers.request.postMessage(JSON.stringify(message));
  } else {
    console.error('Native Protocol is not supported', JSON.stringify(message));
  }
}

// ===========================================================================
// 네이티브 프로토콜 타입 반환
// ===========================================================================
export function getWebViewType() {
  if (isAndroid()) return 'Android Native App WebView';
  if (isIOS()) return 'iOS Native App WebView';

  return 'Browser';
}

// ===========================================================================
// 네이티브 프로토콜 지원 여부 확인
// ===========================================================================
export function isNative(){
  return isAndroid() || isIOS();
}

// ===========================================================================
// 네이티브 프로토콜 버전 반환
// ===========================================================================
export function getAppVersion(){
  request({
    name: 'getAppVersion',
  });
}

// ===========================================================================
// 구글 로그인
// ===========================================================================
export function googleLogin(){
  request({
    name: 'googleLogin',
  });
}

// ===========================================================================
// 카카오 로그인
// ===========================================================================
export function kakaoLogin(){
  request({
    name: 'kakaoLogin',
  });
}

// ===========================================================================
// 페이스북 로그인
// ===========================================================================
export function facebookLogin(){
  request({
    name: 'facebookLogin',
  });
}

// ===========================================================================
// 리워드 광고 호출
// ===========================================================================
export function rewardAds(adUnitId: string){
  request({
    name: 'rewardAds',
    adMobRewardAdUnitID: adUnitId,
  });
}

// ===========================================================================
// 구매 상품 목록 조회
// ===========================================================================
export function getPurchaseProductList(productIds: string[]){
  request({
    name: 'getPurchaseProductList',
    productIds: productIds,
  });
}

// ===========================================================================
// 구매 상품 구매
// ===========================================================================
export function purchaseProduct(productId: string, orderId: string){
  request({
    name: 'purchaseProduct',
    productId: productId,
    orderId: orderId,
  });
}